import Empty from 'antd/es/empty';
import Form from 'antd/es/form';
import React, {forwardRef, useImperativeHandle} from 'react';

import {
    IAddItemButtonRef,
    IOrgStructureTabProps,
} from 'pages/ais/organization-structure/organization-structure-page.types';
import {ForeignParentsFields} from 'pages/ais/organization-structure/tabs/foreign-parents-tab/foreign-parents-fields/foreign-parents-fields';
import {IAntdFormListProps} from 'shared/types/antd';

interface IForeignParentsListProps extends Required<IAntdFormListProps>, Pick<IOrgStructureTabProps, 'isDisabled'> {}

export const ForeignParentsList = forwardRef<IAddItemButtonRef, IForeignParentsListProps>((
    {
        fields,
        operations,
        errors,
        isDisabled,
    }: IForeignParentsListProps,
    ref,
) => {
    const {add, remove} = operations;

    useImperativeHandle(ref, () => ({
        add,
    }), [add]);

    return (
        <>
            <Form.ErrorList errors={errors} />
            {fields?.length === 0 ? (
                <Empty description="Список пуст" />
            ) : (
                <div className="os-form-list">
                    {fields?.map(field => (
                        <ForeignParentsFields
                            key={field.fieldKey}
                            field={field}
                            onRemove={remove}
                            isDisabled={isDisabled}
                        />
                    ))}
                </div>
            )}
        </>
    );
});
